import ApiClient from "../helpers/ApiClient";
import useSWR from "swr";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

export const useExpenseCategories = () => {
    const APIURL = "/expenses/categories";
    const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
    return { data, error, isLoading, mutatePurchases: mutate };
};

export const createExpenseCategory = async (name) => {
    return await ApiClient.post("/expenses/categories", { name });
};

export const updateExpenseCategory = async (id, name) => {
    return await ApiClient.put(`/expenses/categories/${id}`, { name });
};

export const deleteExpenseCategory = async (id) => {
    return await ApiClient.delete(`/expenses/categories/${id}`);
};

export const useExpenses = (from, to) => {
    const APIURL = `/expenses?from=${from || ''}&to=${to || ''}`;
    const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
    return { data, error, isLoading, mutateExpenses: mutate };
};

export const createExpense = async (expense) => {
    return await ApiClient.post("/expenses", expense);
};

export const deleteExpense = async (id) => {
    return await ApiClient.delete(`/expenses/${id}`);
};

export const settleExpenseDue = async (id, { payment_method, date, notes }) => {
    return await ApiClient.post(`/expenses/${id}/settle`, { payment_method, date, notes });
};
